module.exports = __webpack_public_path__ + "img/xmzt_1.782be824.png";